import { all } from 'redux-saga/effects'


export default function* rootSaga(_getState) {
  yield all([
  ])
}
